export default __webpack_public_path__ + "static/media/portError.e49d82ac.svg";